export default __webpack_public_path__ + "static/slider-3-45194ad436cd244ffcde3719e7c934be.webp";